import { RoomJob } from "../models/sales";

const getAllMaterialsFromRoom = (room?: RoomJob) => {
  const materialsFromRoom = [...(room?.materials || [])];

  if (room?.itemsJob && room.itemsJob?.length > 0) {
    room.itemsJob.forEach((item) => {
      if (item?.itemJob?.packingMaterials && item?.itemJob?.packingMaterials?.length > 0) {
        item?.itemJob?.packingMaterials?.forEach((material) => {
          materialsFromRoom.push({
            ...material,
            itemJob: {
              description: item?.itemJob?.description,
              roomId: item?.itemJob?.roomId,
              quantity: item?.itemJob?.quantity,
            },
            quantity: item?.itemJob?.quantity || 1,
          });
        });
      }
    });
  }

  return materialsFromRoom;
};

export default getAllMaterialsFromRoom;
